export interface RadioTrack {
  id: string;
  title: string;
  genre: string;
  bpm: number;
  notes: number[];
  bassNotes: number[];
}

export const RADIO_TRACKS: RadioTrack[] = [
  // 1-5: Synthwave & Cyberpunk
  { id: 'synth_1', title: 'Neon Horizon', genre: 'Synthwave', bpm: 110, notes: [440, 523.25, 659.25, 523.25, 440, 587.33, 659.25, 587.33], bassNotes: [220, 220, 174.61, 174.61] },
  { id: 'synth_2', title: 'Cyber City 2099', genre: 'Cyberpunk', bpm: 120, notes: [587.33, 659.25, 698.46, 659.25, 587.33, 523.25, 440, 493.88], bassNotes: [146.83, 146.83, 174.61, 174.61] },
  { id: 'synth_3', title: 'Outrun Drive', genre: 'Retrowave', bpm: 115, notes: [659.25, 783.99, 880, 783.99, 659.25, 587.33, 523.25, 440], bassNotes: [220, 220, 164.81, 164.81] },
  { id: 'synth_4', title: 'Grid Runner', genre: 'Darksynth', bpm: 125, notes: [440, 466.16, 523.25, 466.16, 440, 392, 440, 523.25], bassNotes: [110, 110, 130.81, 130.81] },
  { id: 'synth_5', title: 'Midnight Cruise', genre: 'Chillwave', bpm: 105, notes: [329.63, 392, 493.88, 587.33, 493.88, 392, 329.63, 293.66], bassNotes: [164.81, 164.81, 146.83, 146.83] },

  // 6-10: 8-Bit Chiptune Arcade
  { id: 'chip_1', title: 'Pixel Overdrive', genre: '8-Bit Chiptune', bpm: 130, notes: [523.25, 659.25, 783.99, 1046.5, 783.99, 659.25, 587.33, 698.46], bassNotes: [261.63, 261.63, 196, 196] },
  { id: 'chip_2', title: 'Super Jumper', genre: 'NES Classic', bpm: 135, notes: [659.25, 659.25, 0, 659.25, 0, 523.25, 659.25, 783.99], bassNotes: [196, 196, 261.63, 261.63] },
  { id: 'chip_3', title: 'Boss Battle', genre: '8-Bit Action', bpm: 140, notes: [440, 440, 523.25, 440, 587.33, 523.25, 440, 392], bassNotes: [110, 110, 146.83, 146.83] },
  { id: 'chip_4', title: 'Game Over Jingle', genre: 'Retro Arcade', bpm: 120, notes: [523.25, 493.88, 466.16, 440, 392, 349.23, 329.63, 293.66], bassNotes: [130.81, 130.81, 110, 110] },
  { id: 'chip_5', title: 'Level Select', genre: '16-Bit RPG', bpm: 110, notes: [587.33, 739.99, 880, 739.99, 587.33, 440, 493.88, 587.33], bassNotes: [146.83, 146.83, 220, 220] },

  // 11-15: Lo-Fi Chill Arcade
  { id: 'lofi_1', title: 'Midnight Arcade', genre: 'Lo-Fi Chill', bpm: 90, notes: [329.63, 392, 493.88, 392, 349.23, 440, 523.25, 440], bassNotes: [164.81, 164.81, 174.61, 174.61] },
  { id: 'lofi_2', title: 'Rainy Quarter', genre: 'Lo-Fi Beats', bpm: 85, notes: [440, 493.88, 523.25, 587.33, 523.25, 493.88, 440, 392], bassNotes: [220, 220, 196, 196] },
  { id: 'lofi_3', title: 'Coffee & Joystick', genre: 'Chillhop', bpm: 92, notes: [523.25, 587.33, 659.25, 698.46, 659.25, 587.33, 523.25, 440], bassNotes: [261.63, 261.63, 220, 220] },
  { id: 'lofi_4', title: 'Sunset Boulevard', genre: 'Ambient Lounge', bpm: 88, notes: [349.23, 440, 523.25, 659.25, 523.25, 440, 349.23, 329.63], bassNotes: [174.61, 174.61, 164.81, 164.81] },
  { id: 'lofi_5', title: 'Dreamy Pixel', genre: 'Dream Pop', bpm: 95, notes: [493.88, 587.33, 739.99, 587.33, 493.88, 440, 369.99, 440], bassNotes: [246.94, 246.94, 220, 220] },

  // 16-20: Electro Arcade & Space Synth
  { id: 'electro_1', title: 'Laser Tag', genre: 'Electro Arcade', bpm: 128, notes: [659.25, 783.99, 987.77, 783.99, 659.25, 587.33, 493.88, 587.33], bassNotes: [164.81, 164.81, 246.94, 246.94] },
  { id: 'electro_2', title: 'Space Odyssey', genre: 'Space Synth', bpm: 118, notes: [523.25, 659.25, 783.99, 880, 1046.5, 880, 783.99, 659.25], bassNotes: [261.63, 261.63, 220, 220] },
  { id: 'electro_3', title: 'Speedway 84', genre: 'Hi-NRG Retro', bpm: 132, notes: [440, 523.25, 659.25, 880, 659.25, 523.25, 440, 392], bassNotes: [220, 220, 196, 196] },
  { id: 'electro_4', title: 'Starlight Zone', genre: 'Sega Synth', bpm: 124, notes: [587.33, 698.46, 880, 1046.5, 880, 698.46, 587.33, 523.25], bassNotes: [146.83, 146.83, 220, 220] },
  { id: 'electro_5', title: 'Arcade Final Boss', genre: 'Darksynth Electro', bpm: 138, notes: [440, 466.16, 440, 523.25, 440, 466.16, 587.33, 523.25], bassNotes: [110, 110, 146.83, 146.83] },
];

export class BackgroundRadio {
  private static ctx: AudioContext | null = null;
  private static currentTrackIndex = 0;
  private static isPlaying = false;
  private static volume = 0.25;
  private static step = 0;
  private static intervalId: number | null = null;
  public static userMuted = false;

  static init(): void {
    if (typeof localStorage !== 'undefined') {
      const saved = localStorage.getItem('arcade_bgm_muted');
      if (saved !== null) {
        this.userMuted = saved === 'true';
      }
    }
  }

  private static getContext(): AudioContext | null {
    if (!this.ctx && typeof window !== 'undefined') {
      const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
      if (AudioCtx) {
        this.ctx = new AudioCtx();
      }
    }
    if (this.ctx && this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
    return this.ctx;
  }

  static autoStart(): void {
    this.init();
    if (this.userMuted) return;

    // Attempt auto play
    this.play();

    // Fallback: Start audio context on first user click if browser policy blocked initial auto play
    const handleFirstInteraction = () => {
      if (!this.isPlaying) {
        this.play();
      }
      window.removeEventListener('click', handleFirstInteraction);
      window.removeEventListener('keydown', handleFirstInteraction);
    };
    window.addEventListener('click', handleFirstInteraction);
    window.addEventListener('keydown', handleFirstInteraction);
  }

  static play(): void {
    const ctx = this.getContext();
    if (!ctx) return;
    
    if (this.isPlaying && this.intervalId !== null) return; // Prevent multiple intervals

    this.isPlaying = true;
    if (this.intervalId !== null) clearInterval(this.intervalId);

    const track = RADIO_TRACKS[this.currentTrackIndex];
    const stepDuration = (60 / track.bpm / 2) * 1000;

    this.intervalId = window.setInterval(() => {
      if (!this.isPlaying) return;
      this.playStep(track);
    }, stepDuration);
  }

  static pause(): void {
    this.isPlaying = false;
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  static toggle(): boolean {
    this.userMuted = !this.userMuted;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('arcade_bgm_muted', String(this.userMuted));
    }
    
    if (this.userMuted) {
      this.pause();
    } else {
      this.play();
    }
    return !this.userMuted;
  }

  static nextTrack(): RadioTrack {
    this.currentTrackIndex = (this.currentTrackIndex + 1) % RADIO_TRACKS.length;
    if (this.isPlaying) {
      this.play();
    }
    return RADIO_TRACKS[this.currentTrackIndex];
  }

  static setVolume(vol: number): void {
    this.volume = Math.max(0, Math.min(1, vol));
  }

  static get currentTrack(): RadioTrack {
    return RADIO_TRACKS[this.currentTrackIndex];
  }

  static get playing(): boolean {
    return this.isPlaying;
  }

  private static playStep(track: RadioTrack): void {
    try {
      const ctx = this.getContext();
      if (!ctx || this.volume <= 0) return;

      const freq = track.notes[this.step % track.notes.length];
      const bassFreq = track.bassNotes[Math.floor(this.step / 2) % track.bassNotes.length];

      if (freq > 0) {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = track.genre.includes('8-Bit') ? 'square' : 'triangle';
        osc.frequency.setValueAtTime(freq, ctx.currentTime);

        gain.gain.setValueAtTime(this.volume * 0.08, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.14);

        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.14);
      }

      if (bassFreq > 0) {
        const bassOsc = ctx.createOscillator();
        const bassGain = ctx.createGain();
        bassOsc.type = 'sine';
        bassOsc.frequency.setValueAtTime(bassFreq, ctx.currentTime);

        bassGain.gain.setValueAtTime(this.volume * 0.12, ctx.currentTime);
        bassGain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.22);

        bassOsc.connect(bassGain);
        bassGain.connect(ctx.destination);
        bassOsc.start();
        bassOsc.stop(ctx.currentTime + 0.22);
      }

      this.step++;
    } catch {
      // Audio context autoplay restriction fallback
    }
  }
}
